/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

export default {
    CUSTOMERS_title: "Customers",
    CUSTOMERS_create: "Create a customer",
    CUSTOMERS_edit: "Update the customer",
    CUSTOMERS_fieldEmail: "Account email",
    CUSTOMERS_fieldBillingEmail: "Billing email",
    CUSTOMERS_fieldPhone: "Phone",
    CUSTOMERS_fieldName: "Customer name",
    CUSTOMERS_fieldStreet: "Street",
    CUSTOMERS_fieldCity: "City",
    CUSTOMERS_fieldPostalCode: "Postal code",
    CUSTOMERS_fieldCompany: "Company",
    CUSTOMERS_fieldNote: "Note",
    CUSTOMERS_fieldDescription: "Note",
    CUSTOMERS_fieldCountry: "Country",
    CUSTOMERS_fieldVAT: "VAT number",
    CUSTOMERS_fieldIsStaff: "Staff",
    CUSTOMERS_confirmCreate: "Create the customer",
    CUSTOMERS_confirmEdit: "Update the customer",
    CUSTOMERS_columnEmail: "Account email",
    CUSTOMERS_columnName: "Contact name",
    CUSTOMERS_columnAddress: "Address",
    CUSTOMERS_columnCountry: "Country",
    CUSTOMERS_columnCompany: "Company",
    CUSTOMERS_columnNote: "Note",
    CUSTOMERS_columnState: "State",
    CUSTOMERS_columnCreated: "Created at",
    GLOBAL_filterCustomerName: "Contact name",
    GLOBAL_filterCustomerPlaceholder: "Filter by contact name",
    CUSTOMERS_filterCompany: "Company",
    CUSTOMERS_filterCompanyPlaceholder: "Filter by company",
    CUSTOMERS_filterEmail: "Email",
    CUSTOMERS_filterEmailPlaceholder: "Filter",
    CUSTOMERS_filterAddress: "Address",
    CUSTOMERS_filterSearch: "Search",
    CUSTOMERS_filterSearchPlaceholder: "Company, contact, e-mail, phone, address",
    CUSTOMERS_filterPhone: "Phone",
    CUSTOMERS_filterPhonePlaceholder: "Phone number",
    CUSTOMERS_filterAddressPlaceholder: "Filter by address",

    CUSTOMER_Details: "Customer Details",
    CUSTOMER_accountInformation: "Account information",
    CUSTOMER_invoiceInformation: "Invoice information",
    CUSTOMER_Description: "Note",
    CUSTOMER_addDescription: "Note",
    CUSTOMER_fieldPlaceholderVAT: "VAT number",
    CUSTOMER_fieldPlaceholderEmail: "Email",
    CUSTOMER_fieldPlaceholderBillingEmail: "Billing email",
    CUSTOMER_fieldPlaceholderName: "Client name",
    CUSTOMER_fieldPlaceholderAddress: "Address",
    CUSTOMER_fieldPlaceholderCompany: "Company",
    CUSTOMER_fieldPlaceholderNote: "Note",
    CUSTOMERS_fieldInvoicePrefix: "Invoice prefix",

    CUSTOMERS_createSuccessTitle: "Notification",
    CUSTOMERS_createSuccessMessage: "New Customer created successfully",
    CUSTOMERS_deleteConfirm: "Are you sure you want to delete this customer ? | \
        Are you sure you want to delete these customers ?",
    CUSTOMER_deleteConfirm: "Are you sure you want to delete this customer ?",
    CUSTOMERS_cannotDelete: "Some of the selected customers cannot be deleted",
    CUSTOMERS_label: "Customer",
    CUSTOMERS_plural_label: "Customers",
    CUSTOMERS_splashScreenTitle: "Create your first customer",
    CUSTOMERS_splashScreenDescription: "A person type customer eg. Mrs Pauline GERMAIN",

    CUSTOMERS_formChanged: "No changes | You have changed {} field of the customer | \
        You have changed {count} fields of the customer",
    CUSTOMERS_updated: "Customer updated",

    CUSTOMERS_endTrial: "End the trial period",
    CUSTOMERS_endTrialConfirm: "Are you sure you want to end trial period for this customer ? | \
        Are you sure you want to end trial period for these customers ?",
    CUSTOMER_endTrial: "The trial period ended successfully",

    CUSTOMERS_actionSubscriptions: "Subscriptions",
    CUSTOMERS_actionGroupUsers: "View users",
    Customer_taxIdInvalid: "Invalid tax number",

    CUSTOMERS_invoicesTitle: "Invoices",
    CUSTOMERS_invoicesEmpty: "No invoices",
    CUSTOMERS_invoiceRejected: "REJECTED",
    CUSTOMERS_paymentsTitle: "Payments",
    CUSTOMERS_paymentsEmpty: "No payments",
    CUSTOMERS_paymentMethodValidity: "Valid until {0}",
    CUSTOMERS_paymentMandateDownload: "Download SEPA mandate",
    CUSTOMERS_subscriptionsTitle: "Subscription",
    CUSTOMERS_quotasTitle: "Quotas",
    CUSTOMERS_quotasEmpty: "No subscription: no quotas to show.",
    CUSTOMERS_subscriptionsEmpty: "No subscription",

    CUSTOMERS_usersTitle: "Users",
    CUSTOMERS_userAccountOwner: "Account owner",
    CUSTOMERS_usersEmpty: "No users",
    CUSTOMERS_userColumnName: "Name",
    CUSTOMERS_userColumnEmail: "Email",
    CUSTOMERS_userColumnPhone: "Phone",
    CUSTOMERS_userColumnStatus: "Status",
    CUSTOMERS_userColumnCreated: "Created at",
    CUSTOMERS_userColumnLastActivity: "Last login",
    CUSTOMERS_userColumnGroup: "Group",
    CUSTOMERS_userColumnCompany: "Company",
    CUSTOMERS_userColumnOwner: "Owner",
    CUSTOMERS_userStatusActive: "Active",
    CUSTOMERS_userStatusProcessing: "Pending approval",
    CUSTOMERS_userStatusInactive: "Inactive",
    CUSTOMERS_userFilterAll: "All statuses",
    CUSTOMERS_userSearchPlaceholder: "Search a user"
};
